import React from 'react'
import {Route, Redirect} from 'react-router-dom'
import {connect} from 'react-redux'
import AuthLayout from 'layouts/Auth'

const  AuthRoute = ({component:Component, authenticated, admin, coach, authChecked, loading, ...rest}) => {

    return (
        <Route {...rest}
            render = {(props) => {

                if (authenticated === true ){
                    // Wait for user role state to be properly loaded before redirecting
                    if (!authChecked || (admin === undefined && coach === undefined) || loading === true) {
                        return <AuthLayout><Component {...props}/></AuthLayout>; // Stay on login page while loading
                    }

                    if (admin === true ){
                        return <Redirect to = "/admin/dashboard"/>
                    } else if (coach === true) {
                        return <Redirect to = "/client/coach-dashboard"/>
                    } else {
                        // return <Redirect to = "/client/dashboard"/>
                        return <Redirect to = "/client/home"/>
                    }
                } else {
                    return <AuthLayout><Component {...props}/></AuthLayout>
                }
            }}
        />
)}
const mapStateToProps = (state) => ({
    authenticated: state.loginAuth.authenticated,
    admin: state.loginAuth.admin,
    coach: state.loginAuth.userDetails?.coach,
    authChecked: state.loginAuth.authChecked,
    loading: state.loginAuth.loading
})

export default connect(mapStateToProps)(AuthRoute)
